import { AlertsModule } from '../alerts/alerts.module';
import { FinderContainerComponent } from './finder-container/finder-container.component';
import { ProgressDialogComponent } from './progress-dialog/progress-dialog.component';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { CommonDialogsService } from './common-dialogs.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationDialogComponent } from './notification-dialog/notification-dialog.component';
import { DefaultDialogLayoutComponent } from './default-dialog-layout/default-dialog-layout.component';
import { DynamicComponentInjectorModule } from '../dynamic-component-injector/dynamic-component-injector.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReplaceLineBreaksPipe } from 'idk/pipes/html-pipes/replace-line-breaks.pipe';
import { HtmlPipesModule } from 'idk/pipes/html-pipes/html-pipes.module';

@NgModule({
    declarations: [
        AlertDialogComponent,
        ConfirmDialogComponent,
        ErrorDialogComponent,
        ProgressDialogComponent,
        FinderContainerComponent,
        NotificationDialogComponent,
        DefaultDialogLayoutComponent,
    ],
    providers: [CommonDialogsService],
    imports: [
        CommonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        AlertsModule,
        DynamicComponentInjectorModule,
        HtmlPipesModule,
    ],
    exports: [MatDialogModule, MatProgressSpinnerModule, MatIconModule],
})
export class CommonDialogsModule {}
